import { render, staticRenderFns } from "./ExploreManagerPage.vue?vue&type=template&id=0af2ca65"
import script from "./ExploreManagerPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExploreManagerPage.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0af2ca65')) {
      api.createRecord('0af2ca65', component.options)
    } else {
      api.reload('0af2ca65', component.options)
    }
    module.hot.accept("./ExploreManagerPage.vue?vue&type=template&id=0af2ca65", function () {
      api.rerender('0af2ca65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/pages/manager/explore/ExploreManagerPage.vue"
export default component.exports